<template>
  <div>
    <h1>{{ searchKey }}<span>{{$t('upgrade_page_views_search_list_index_480')}}</span></h1>
    <div class="list-wrap">
      <div v-for="item in list" :key="item.id">
        <player-item
          v-if="item.uuid"
          :item="{
            ...item.minSkill,
            nickname: item.nickname,
            userLevel: item.userLevel,
            faceSuccess: item.faceSuccess
          }"
        />
        <div v-else></div>
      </div>
      <div v-show="!list.length" class="empty">
        <div v-show="loading" class="loading">
          <i class="el-icon-loading"></i>
        </div>
        <div v-show="!loading">
          <img src="~@/assets/image/background/empty-search.png" />
          <p>{{$t('upgrade_page_views_player_list_index_184')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlayerItem from '@/upgrade-page/views/player-list/player-item';

export default {
  components: {
    PlayerItem
  },
  data() {
    return {
      loading: false,
      searchKey: '',
      list: []
    };
  },
  computed: {
    time() {
      return this.$route.query.t;
    }
  },
  watch: {
    time() {
      this.init();
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.$route.name !== 'searchList') return; // 避免离开页面，也触发搜索，产生额外request的问题
      const { keyword } = this.$route.params;
      const searchKey = decodeURIComponent(keyword);
      if (!searchKey || searchKey === ' ') {
        this.$router.go(-1);
      }
      this.searchKey = searchKey;
      if (!this.$parent) return;
      this.$parent.showSearch = false;
      this.$parent.searching = true;
      this.loading = true;
      this.$http.get('/user/search', { searchKey }).then(({ data }) => {
        this.$parent.searching = false;
        this.list = (data || []).map(item => ({
          ...item,
          id: item.uuid,
          minSkill: {
            ...item.minSkill,
            avatarImageUrl: item.avatarUrl
          }
        }));
        const len = this.list.length;
        if (len) {
          // 補充至4n
          for (let i = 0; i < this.$util.addListItem(len, 5); i++) {
            this.list.push({
              id: i
            });
          }
        }
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  span {
    color: $color-gray-3;
    margin-left: 10px;
  }
}
.list-wrap {
  @include flex(space-between, flex-start);
  flex-wrap: wrap;
  margin-top: 30px;
  padding-bottom: 60px;
  > * {
    width: 207px;
    margin-top: 24px;
  }
}
.empty {
  margin: 82px auto 0;
  .loading {
    text-align: center;
    color: $color-gray-2;
    font-size: 30px;
  }
  img {
    display: block;
    width: 108px;
    margin: 0 auto;
  }
  p {
    margin-top: 20px;
    text-align: center;
    color: $color-gray-3;
    font-size: 14px;
  }
}
</style>
